module.exports = __webpack_public_path__ + "static/media/grinder_v2.a57ddd4e.png";